module.exports = __webpack_public_path__ + "img/error-icon.fe2653ff.png";